module.exports = __webpack_public_path__ + "static/media/busd.ce42ac30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/busd.png
// module id = 2387
// module chunks = 7